var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.281041 13.7218C-0.0938054 14.0968 -0.0936621 14.7047 0.281361 15.0796C0.656385 15.4544 1.26427 15.4543 1.63912 15.0793L7.5668 9.15221C7.59682 9.12212 7.63758 9.10521 7.68008 9.10521C7.72259 9.10521 7.76334 9.12212 7.79336 9.15221L13.721 15.0805C13.9635 15.3231 14.317 15.4179 14.6483 15.3292C14.9797 15.2405 15.2385 14.9818 15.3274 14.6505C15.4162 14.3192 15.3216 13.9657 15.0791 13.7231L9.15208 7.79349C9.12199 7.76348 9.10508 7.72272 9.10508 7.68021C9.10508 7.63771 9.12199 7.59695 9.15208 7.56693L15.0804 1.63925C15.4552 1.26388 15.4548 0.655701 15.0794 0.280854C14.7041 -0.0939926 14.0959 -0.0935628 13.721 0.281814L7.79336 6.20821C7.76334 6.23831 7.72259 6.25522 7.68008 6.25522C7.63758 6.25522 7.59682 6.23831 7.5668 6.20821L1.63912 0.281814C1.26427 -0.0932094 0.656385 -0.0933526 0.281361 0.281494C-0.0936621 0.656341 -0.0938054 1.26423 0.281041 1.63925L6.20808 7.56693C6.23817 7.59695 6.25509 7.63771 6.25509 7.68021C6.25509 7.72272 6.23817 7.76348 6.20808 7.79349L0.281041 13.7218Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.2697312bb55f878ebad73b31a330d4e0.svg";
export { ForwardRef as ReactComponent };